import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const cityData: Record<string, {
  name: string;
  region: string;
  description: string;
  longDescription: string;
  postcodeExamples: string[];
  nearbyAreas: string[];
  lat: number;
  lng: number;
}> = {
  cardiff: {
    name: 'Cardiff',
    region: 'South Wales',
    description: 'Find Local Trade Jobs in Cardiff — Get Paid Fast',
    longDescription: 'Taskbudy connects skilled tradespeople in Cardiff with local, paid work — without bidding, buying leads, or chasing customers. If you\'re a handyman, plumber, electrician, cleaner, waste removal specialist, or driver, we send available jobs directly to you. Choose the jobs you want, work ASAP or scheduled, and get paid with clear pricing and full support.',
    postcodeExamples: ['CF10', 'CF11', 'CF14', 'CF23', 'CF24'],
    nearbyAreas: ['Penarth', 'Barry', 'Caerphilly', 'Pontypridd', 'Newport'],
    lat: 51.4816,
    lng: -3.1791
  },
  london: {
    name: 'London',
    region: 'Greater London',
    description: 'Flexible Trade Jobs Across London — No Bidding Required',
    longDescription: 'Looking for trade jobs in London? Taskbudy gives you access to high-volume local work across Greater London. Jobs are sent directly to you based on your trade, location, and availability. No quotes. No lead fees. Just real jobs and fast payments.',
    postcodeExamples: ['SW1', 'E1', 'N1', 'W1', 'SE1'],
    nearbyAreas: ['Westminster', 'Camden', 'Islington', 'Hackney', 'Tower Hamlets'],
    lat: 51.5074,
    lng: -0.1278
  },
  birmingham: {
    name: 'Birmingham',
    region: 'West Midlands',
    description: 'Local Trade Work in Birmingham — When You Want It',
    longDescription: 'Taskbudy helps tradespeople in Birmingham find consistent, local jobs without the hassle of traditional platforms. Once approved, jobs are sent directly to you — you decide what to accept. Perfect for self-employed trades and small businesses.',
    postcodeExamples: ['B1', 'B2', 'B5', 'B15', 'B29'],
    nearbyAreas: ['Solihull', 'Sutton Coldfield', 'West Bromwich', 'Wolverhampton', 'Coventry'],
    lat: 52.4862,
    lng: -1.8904
  },
  manchester: {
    name: 'Manchester',
    region: 'Greater Manchester',
    description: 'Trade Jobs in Manchester — Simple, Fair & Flexible',
    longDescription: 'Looking for handyman, plumbing, electrical, cleaning, or waste removal jobs in Manchester? Taskbudy connects you with customers nearby — no bidding, no wasted time. Work when it suits you and get paid clearly for every job.',
    postcodeExamples: ['M1', 'M4', 'M15', 'M20', 'M21'],
    nearbyAreas: ['Salford', 'Stockport', 'Bolton', 'Oldham', 'Rochdale'],
    lat: 53.4808,
    lng: -2.2426
  },
  leeds: {
    name: 'Leeds',
    region: 'West Yorkshire',
    description: 'Find Trade Jobs Near You in Leeds',
    longDescription: 'Taskbudy provides local job opportunities for tradespeople in Leeds. Jobs are matched to your trade and area, so you only see work that\'s relevant to you. No subscriptions. No lead costs. Just honest work.',
    postcodeExamples: ['LS1', 'LS2', 'LS6', 'LS11', 'LS17'],
    nearbyAreas: ['Bradford', 'Wakefield', 'Huddersfield', 'Halifax', 'Dewsbury'],
    lat: 53.8008,
    lng: -1.5491
  },
  liverpool: {
    name: 'Liverpool',
    region: 'Merseyside',
    description: 'Local Trade Jobs in Liverpool — No Lead Fees',
    longDescription: 'If you\'re a tradesperson in Liverpool looking for reliable work, Taskbudy sends real customer jobs directly to you. You choose when to work and which jobs to take. Support is available whenever you need it.',
    postcodeExamples: ['L1', 'L3', 'L8', 'L15', 'L18'],
    nearbyAreas: ['Birkenhead', 'Bootle', 'St Helens', 'Warrington', 'Widnes'],
    lat: 53.4084,
    lng: -2.9916
  },
  bristol: {
    name: 'Bristol',
    region: 'South West England',
    description: 'Bristol Trade Jobs — Work on Your Schedule',
    longDescription: 'Taskbudy connects Bristol-based tradespeople with customers nearby for same-day and scheduled work. No bidding wars, no chasing quotes — just straightforward jobs. Ideal for independent trades and small teams.',
    postcodeExamples: ['BS1', 'BS2', 'BS5', 'BS8', 'BS16'],
    nearbyAreas: ['Bath', 'Weston-super-Mare', 'Clevedon', 'Portishead', 'Yate'],
    lat: 51.4545,
    lng: -2.5879
  },
  sheffield: {
    name: 'Sheffield',
    region: 'South Yorkshire',
    description: 'Find Local Trade Work in Sheffield',
    longDescription: 'From handyman and plumbing jobs to cleaning and waste removal, Taskbudy helps Sheffield tradespeople find work without the usual hassle. Set your availability, accept the jobs you want, and get paid fairly.',
    postcodeExamples: ['S1', 'S2', 'S6', 'S10', 'S11'],
    nearbyAreas: ['Rotherham', 'Doncaster', 'Barnsley', 'Chesterfield', 'Worksop'],
    lat: 53.3811,
    lng: -1.4701
  },
  nottingham: {
    name: 'Nottingham',
    region: 'East Midlands',
    description: 'Trade Jobs in Nottingham — Flexible & Local',
    longDescription: 'Taskbudy offers tradespeople in Nottingham a smarter way to find local work. Jobs are matched to your skills and area, so you stay productive without wasting time. No contracts. No pressure.',
    postcodeExamples: ['NG1', 'NG2', 'NG5', 'NG7', 'NG8'],
    nearbyAreas: ['Derby', 'Mansfield', 'Newark', 'Beeston', 'West Bridgford'],
    lat: 52.9548,
    lng: -1.1581
  },
  leicester: {
    name: 'Leicester',
    region: 'East Midlands',
    description: 'Local Trade Jobs in Leicester — Get Started Fast',
    longDescription: 'If you\'re a tradesperson in Leicester, Taskbudy helps you find local customers quickly. Once approved, you\'ll receive job requests you can accept or decline. Simple, flexible, and transparent.',
    postcodeExamples: ['LE1', 'LE2', 'LE3', 'LE4', 'LE5'],
    nearbyAreas: ['Loughborough', 'Hinckley', 'Market Harborough', 'Melton Mowbray', 'Coalville'],
    lat: 52.6369,
    lng: -1.1398
  }
};

export default function TradeJobsCity() {
  const { city } = useParams();
  const cityName = city ? city.charAt(0).toUpperCase() + city.slice(1).replace(/-/g, ' ') : '';

  useEffect(() => {
    // Set document title
    document.title = `Trade Jobs in ${cityName} | Local Handyman, Plumber & Electrician Jobs - Taskbudy`;
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', `Find local trade jobs in ${cityName}. Browse handyman, plumbing, electrical, cleaning, waste removal & transport jobs. Join Taskbudy as a verified service provider and get instant job dispatch in ${cityName}.`);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = `Find local trade jobs in ${cityName}. Browse handyman, plumbing, electrical, cleaning, waste removal & transport jobs. Join Taskbudy as a verified service provider and get instant job dispatch in ${cityName}.`;
      document.head.appendChild(meta);
    }

    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', `trade jobs ${cityName}, handyman jobs ${cityName}, plumber jobs ${cityName}, electrician jobs ${cityName}, cleaner jobs ${cityName}, local trade work ${cityName}, service provider jobs ${cityName}`);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = `trade jobs ${cityName}, handyman jobs ${cityName}, plumber jobs ${cityName}, electrician jobs ${cityName}, cleaner jobs ${cityName}, local trade work ${cityName}, service provider jobs ${cityName}`;
      document.head.appendChild(meta);
    }

    // Set canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://taskbudy.co.uk/trade-jobs-${city}`);
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = `https://taskbudy.co.uk/trade-jobs-${city}`;
      document.head.appendChild(link);
    }

    // Set noindex for provider acquisition pages to avoid SEO competition
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, nofollow';
      document.head.appendChild(meta);
    }
  }, [city, cityName]);

  return (
    <>
      {/* Page content here */}
    </>
  );
}
